export const AUTH_STATUS_URL = "apis/meta/v2/authStatus";
